import "../../../styles/DashboardStyles/DashboardContent/DashboardWelcome.css";

export default function DashboardWelcome() {
  return (
    <div className="welcome-root">

      {/* Top badge */}
      <div className="welcome-badge">
        <span className="welcome-badge-dot" />
        SAHPRA Licensed Consultancy
      </div>

      {/* Heading */}
      <h1 className="welcome-title">
        Welcome to <span className="welcome-title-accent">Kole Medical</span>
      </h1>

      {/* Divider */}
      <div className="welcome-divider" />

      {/* Body text */}
      <p className="welcome-desc">
        Any business involved in the manufacturing, importing, distributing,
        or selling of medical devices is <strong>legally required</strong> to
        obtain a valid SAHPRA establishment licence. This licence is also
        essential for companies that want to qualify for government and
        provincial tenders.
      </p>

      <p className="welcome-desc">
        At <strong>Kole Medical</strong>, we simplify this complex process by
        guiding you through every step — from licence application and document
        preparation to regulatory compliance and approval.
      </p>

      {/* Feature cards */}
      <div className="welcome-cards">
        <div className="welcome-card">
          <div className="welcome-card-icon">📋</div>
          <h3>Licence Application</h3>
          <p>End-to-end assistance with your SAHPRA establishment licence submission.</p>
        </div>
        <div className="welcome-card">
          <div className="welcome-card-icon">📁</div>
          <h3>Document Preparation</h3>
          <p>We prepare and review all required regulatory documentation on your behalf.</p>
        </div>
        <div className="welcome-card">
          <div className="welcome-card-icon">✅</div>
          <h3>Compliance & Approval</h3>
          <p>Ongoing support to ensure full compliance through to licence approval.</p>
        </div>
      </div>

      {/* CTA */}
      <div className="welcome-cta">
        <p className="welcome-cta-text">Ready to get started?</p>
        <div className="welcome-cta-actions">
          <a href="/dashboard/quote" className="welcome-btn-primary">
            Request a Quote
          </a>
          <a href="/dashboard/applications" className="welcome-btn-secondary">
            View Applications
          </a>
        </div>
      </div>

    </div>
  );
}